import CTNButton from '@ctn/ui/components/ctn-button';
import { CTNIcon } from '@ctn/ui/components/ctn-icon';
import CTNModal from '@ctn/ui/components/ctn-modal';
import { type CTNModalProps } from '@ctn/ui/types/ctn-modal';

import { ROUTES_RESOURCES } from '@/constants/routes.constants';

export type IModalVisorPdf = {
	readonly isShow: boolean;
	readonly archivos?: Array<{nombre: string; url: string}>; 
	readonly onClose: () => void;
};

const HelpModal = ({ isShow, archivos, onClose }: IModalVisorPdf) => {
	const listaArchivos = archivos ?? [
		{
			nombre: 'Manual portal',
			url: `${ROUTES_RESOURCES.DESCARGAS}/RU_PNEP_MU_v.1.1.pdf`,
		},
		{
			nombre: 'Infografía',
			url: `${ROUTES_RESOURCES.DESCARGAS}/RU_PNEP_INF.pdf`,
		},
		{
			nombre: 'Guía de Autorización por Videoconferencia.pdf',
			url: `${ROUTES_RESOURCES.DESCARGAS}/Manual firmar por videoconferencia.pdf`,
		},
		{
			nombre: 'Guía de Acceso a videoconferencia desde PC.pdf',
			url: `${ROUTES_RESOURCES.DESCARGAS}/Manual firmar por PC.pdf`,
		},
		{
			nombre: 'Guía de Acceso a videoconferencia desde móvil.pdf',
			url: `${ROUTES_RESOURCES.DESCARGAS}/Manual firmar por móvil.pdf`,
		}
	];

	const actionButtons: CTNModalProps['actionButtons'] = [
		{
			key: 'tertiary',
			mode: 'tertiary',
			label: 'Cancelar',
			size: 'size-40',
			minWidth: '140',
			onClick: onClose,
		}
	];

	return (
		<CTNModal
			autoHeight
			closeable
			show={isShow}
			type='basic'
			size="xl"
			title="Ayuda"
			className="c-pnp-help-modal"
			actionButtons={actionButtons}
			content={
				<div className="c-pnp-help-modal__guides o-grid">
					{listaArchivos.map((archivo) => (
						<div key={archivo.nombre} className="c-pnp-help-modal__guides-document o-grid__row">
							<span className="o-grid__col-8">
								<CTNIcon icon="pdfDuotone" />
								{archivo.nombre}
							</span>
							<CTNButton
								className="o-grid__col-4"
								label="Ver"
								mode="secondary"
								variant="outline"
								minWidth="100"
								onClick={() => {
									window.open(archivo.url, '_blank', 'noopener,noreferrer');
								}}
							/>
						</div>
					))}
				</div>
			}
			onClose={onClose}
		 />
	);
};

export default HelpModal;
